import { Injectable } from '@angular/core';
import { initData } from '../pages/model/model';
import {  setMenu, clearMenu } from '../pages/pages-menu';

import { Menu } from './general.service';

@Injectable()

export class MenuService {
  modules = [];
  modulesAdmin = [];
  constructor() {}
  public idioma;
  public menu_datos;
  public menu_config;
  public menu_descargas;
  public menu_alertas;

  getMenu( project:initData, rol_user:any ) {

    if(localStorage.getItem("idioma") == null || localStorage.getItem("idioma") == undefined){

      this.idioma = 'es'
    
    }else{
    
      this.idioma = localStorage.getItem("idioma")
    
    }

    if(this.idioma == "es"){
        this.menu_datos = "Datos"
        this.menu_config = "Configuración"
        this.menu_descargas = "Descargas"
        this.menu_alertas = "Alertas"
    }else if(this.idioma == "en"){
        this.menu_datos = "Data"
        this.menu_config = "Settings"
        this.menu_descargas = "Downloads"
        this.menu_alertas = "Alerts"
    }else if(this.idioma == "fr"){
        this.menu_datos = "Données"
        this.menu_config = "Paramètre"
        this.menu_descargas = "Téléchargements"
        this.menu_alertas = "Alertes"
    }else if(this.idioma == "it"){
        this.menu_datos = "Dati"
        this.menu_config = "Impostazione"
        this.menu_descargas = "Scaricamenti"
        this.menu_alertas = "Avvisi"
    }

    if(rol_user == "1" || rol_user == "2"){

      this.modules = [
        {
          title: project.nombre,
          //expanded: false,
          group: false,
          icon: 'arrow-ios-downward-outline',
          children: [
            {
              title: this.menu_datos,
              group: false,
              link: '/pages/datos',
              //icon: 'arrow-ios-downward-outline',
            },
            {
              title: this.menu_config,
              group: false,
              link: '/pages/configuracion',
              //icon: 'arrow-ios-downward-outline',
            },
            {
              title: this.menu_descargas,
              group: false,
              link: '/pages/descargas',
              //icon: 'arrow-ios-downward-outline',
            },
            {
              title: this.menu_alertas,
              group: false,
              link: '/pages/alertas',
              //icon: 'arrow-ios-downward-outline',
            },
          ],
        },
        /*{
          title: 'DATOS',
          group: false,
          link: '/pages/datos',
          icon: 'arrow-ios-downward-outline',
        },
        {
          title: 'CONFIGURACIÓN',
          group: false,
          link: '/pages/configuracion',
          icon: 'arrow-ios-downward-outline',
        },*/
      ]

    }else if(rol_user == "3"){

      this.modules = [
        {
          title: project.nombre,
          //expanded: false,
          group: false,
          icon: 'arrow-ios-downward-outline',
          children: [
            {
              title: this.menu_datos,
              group: false,
              link: '/pages/datos',
              //icon: 'arrow-ios-downward-outline',
            },
            {
              title: this.menu_descargas,
              group: false,
              link: '/pages/descargas',
              //icon: 'arrow-ios-downward-outline',
            }
          ],
        },
        /*{
          title: 'DATOS',
          group: false,
          link: '/pages/datos',
          icon: 'arrow-ios-downward-outline',
        },
        {
          title: 'CONFIGURACIÓN',
          group: false,
          link: '/pages/configuracion',
          icon: 'arrow-ios-downward-outline',
        },*/
      ]


    }

    


    setMenu(this.modules);
  }

  setMenuC(){
    setMenu(this.modules);
  }


  vaciaMenu() {
    clearMenu();
  }





}